/**
 * «Ticket N di M»: posizione del ticket fra quelli della lista, nel loro ordine. `null` se il ticket non
 * ne fa parte (link diretto a un ticket di un'altra pagina o escluso dai filtri) o la lista non è ancora
 * arrivata: meglio nessuna posizione che una sbagliata.
 */
export function ticketPosition(code: string, codes: readonly string[]): string | null {
  const index = codes.indexOf(code.trim().toUpperCase());
  return index < 0 ? null : `Ticket ${index + 1} di ${codes.length}`;
}
